// @ts-check
import {
  StyledGitOrganizationForm,
  StyledList
} from './GitOrganizationForm.style';
import _ from 'lodash';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import Text from 'components/base/Text';
import { StyledWizardFooter } from '../SyncGitTeamsWizard.style';
import { CenterLoader } from 'connected-components/Loader/Loader';
import { LBButton } from '@linearb/buzz';

const ORGS_VIEW_STATE = {
  MISSING_SENSOR: 'missing-sensor',
  LOADING: 'loading',
  RENDERING_ORGS: 'rendering-orgs'
};

const getOrgViewState = ({ githubOrgs, sensorAuthId }) => {
  if (!sensorAuthId) return ORGS_VIEW_STATE.MISSING_SENSOR;
  if (githubOrgs.length === 0) return ORGS_VIEW_STATE.LOADING;
  return ORGS_VIEW_STATE.RENDERING_ORGS;
};

const GitOrganizationForm = ({
  onNext,
  onCancel,
  githubIntegrations,
  githubOrgs,
  sensorAuthId,
  setSensorAuthId,
  selectedOrgName,
  setSelectedOrgName
}) => {
  const orgsViewState = getOrgViewState({ githubOrgs, sensorAuthId });

  return (
    <StyledGitOrganizationForm>
      <Text size='x-medium' mt='1rem'>
        Select GIT integration and org - only one integration is supported at
        this time
      </Text>
      <StyledList className='git-integration-list'>
        <header>GIT INTEGRATIONS</header>
        <main>
          {githubIntegrations.map(githubIntegration => {
            const integrationId = _.get(githubIntegration, 'id');
            const isSelected = sensorAuthId === integrationId;

            return (
              <div
                key={integrationId}
                className={`row git-integration ${boolPropsToClassNames({
                  isSelected
                })}`}
                onClick={() => setSensorAuthId(integrationId)}
              >
                {githubIntegration.name}
              </div>
            );
          })}
        </main>
      </StyledList>

      <StyledList className='git-organization-list'>
        <header>GIT ORGS</header>
        <main
          className={boolPropsToClassNames({
            fullscale:
              orgsViewState === ORGS_VIEW_STATE.LOADING ||
              orgsViewState === ORGS_VIEW_STATE.MISSING_SENSOR
          })}
        >
          {orgsViewState === ORGS_VIEW_STATE.MISSING_SENSOR && (
            <Text size='x-large'>please select Git Integration</Text>
          )}
          {orgsViewState === ORGS_VIEW_STATE.LOADING && <CenterLoader />}
          {orgsViewState === ORGS_VIEW_STATE.RENDERING_ORGS &&
            githubOrgs.map(githubOrg => {
              const orgName = _.get(githubOrg, 'name');
              const isSelected = selectedOrgName === orgName;

              return (
                <div
                  key={orgName}
                  className={`row git-organization ${boolPropsToClassNames({
                    isSelected
                  })}`}
                  onClick={() => setSelectedOrgName(orgName)}
                >
                  {orgName}
                </div>
              );
            })}
        </main>
      </StyledList>

      <StyledWizardFooter>
        <LBButton
          variant='outline'
          size='lg'
          onClick={onCancel}
          data-cy='SyncGitTeamsForm-btn-cancel'
        >
          Cancel
        </LBButton>
        <LBButton
          size='lg'
          data-cy='SyncGitTeamsForm-btn-save'
          disabled={!selectedOrgName}
          onClick={() => onNext(sensorAuthId, selectedOrgName)}
        >
          Next
        </LBButton>
      </StyledWizardFooter>
    </StyledGitOrganizationForm>
  );
};

export default GitOrganizationForm;
